import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import { ILog, ILogsState } from "@/store/modules/logs/state";

export enum LogsMutations {
  SET_ONE = "SET_ONE_LOG",
  SET_ALL = "SET_ALL_LOG",
  SET_LAZY_DATA = "SET_LAZY_DATA_LOG",
}

export const mutations: MutationTree<ILogsState> = {
  [LogsMutations.SET_ONE](state, payload: ILog) {
    state.log = payload;
  },
  [LogsMutations.SET_ALL](state, payload: ILog[]) {
    state.logs = payload;
  },
  [LogsMutations.SET_LAZY_DATA](state, payload: IDataProvider<ILog>) {
    state.dataProvider = payload;
  },
};
